import React from "react"
import { RootData } from "../../../aggregators/rootData/context"
import { getQueryParam } from "../../../utils/url"

export type SearchProvider = "elastic" | "algolia"

export const useProductSearchType = (rootData: RootData) => {
  const [provider, setProvider] = React.useState<SearchProvider>(
    rootData?.websiteSettings?.algolia.productsSearch ? "algolia" : "elastic"
  )

  React.useEffect(() => {
    const searchProviderParam = getQueryParam(window.location, "searchProvider")
    if (searchProviderParam) {
      setProvider(searchProviderParam as SearchProvider)
    }
  }, [])

  return provider
}
